
import { commonfunc } from '~/mixin/common'
import orMixin from '~/mixin/or/orMixin'
import { ugMixin } from '~/mixin/ug/ugMixin'

export default {
  name: 'MyHeader',
  components: {
  },
  filters: {
    comma: (val) => {
      const num = Number(val)
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
    }
  },
  mixins: [commonfunc, orMixin, ugMixin],
  data () {
    return {
      form: {
        mbMngNo: '',
        mbEfnm: '',
        mbEid: '',
        userTy: '',
        crwYn: ''
      },
      form1: {
        mbNknmNm: '',
        intrImgFileId: '', // 첨부파일
        cttsImg: [], // 프로필 이미지 업로드
        profileAtchUrl: '', // 프로필첨부파일Url
        profileAtchNm: '' // 프로필첨부파일이름
      },
      spclMssnCnt: 0,
      zzimPdCnt: 0,
      cmptMssnCnt: 0,
      oftenBuyPdCnt: 0, // 자주 산 상품
      usePnt: 0, // 포인트
      accmAcmy: 0, // 캐시
      cpnCn: 0, // 쿠폰
      blce: 0, // 상품권
      revw: 0, // 작성가능한 리뷰
      rcntPd: 0, // 최근 본 상품
      file: {},
      fileList: [],
      link: '',
      login: !this.isBlank(this.$store.getters['session/getMbMngNo']),
    }
  },
  computed: {
    urlToMbInfo () {
      if (this.form.userTy === '21') {
        return '/mb/mbc/SCR_MBC_0111B'
      } else if (this.form.userTy === '40') {
        return '/mb/mbc/SCR_MBC_0111D_01'
      } else {
        return '/mb/mbc/SCR_MBC_0111A'
      }
    }
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    console.log(this.$store.getters['session/getMbMngNo'])
    if (this.login) {
      this.form.mbMngNo = this.$store.getters['session/getMbMngNo']
      this.form.mbEfnm = this.$store.getters['session/getMbEfnm']
      this.form.mbEid = this.$store.getters['session/getMbEid']
      this.form.userTy = this.$store.getters['session/getUserTy']
      this.form.crwYn = this.$store.getters['session/getCrwYn']

      this.link = await this.getPrfImg()
      this.selPoint()
      this.selAcmyInfo()
      this.selCpnCnt()
      this.selGfCnt()
      this.selPsblRevw()
      // this.selSpclMssn() // 마이페이지 스탬프미션 제외
      this.selZzimPdCnt()
      this.selOftenBuyPdCount()
      this.selRcntPd()
    }
  },
  unmounted () {
  },
  methods: {
    goTo (path) {
      if (this.login) {
        this.$router.push({ path })
      } else {
        this.$router.push({
          name: 'mb-mbb-SCR_MBB_0097A',
          params: { returnUrl: path }
        })
      }
    },

    selPoint () {
      this.$AxiosBuilder
        .data(this.form)
        .build()
        .post('/ms/msb/selPoint')
        .then((res) => {
          if (res.data.data && res.data.data.usePnt) {
            this.usePnt = JSON.parse(JSON.stringify(res.data.data.usePnt))
          }
        })
    },

    selAcmyInfo () {
      this.$AxiosBuilder
        .data(this.form)
        .build()
        .post('/ms/mse/selAcmyInfo')
        .then((res) => {
          if (res.data.data && res.data.data.accmAcmy) {
            this.accmAcmy = JSON.parse(JSON.stringify(res.data.data.acmyBlce))
          }
        })
    },

    selSpclMssn () {
      this.$AxiosBuilder
        .data({ mbMngNo: this.form.mbMngNo, aplMdiaPcomYn: 'Y' })
        .build()
        .post('/ev/evd/selSpclMssn')
        .then((res) => {
          if (res.data.data) {
            this.spclMssnCnt = res.data.data.spclMssnCnt
            this.cmptMssnCnt = res.data.data.cmptMssnCnt
          }
        })
    },
    selZzimPdCnt () {
      try {
        this.$AxiosBuilder
          .data(this.form)
          .build()
          .post('/pd/pdt/zzim/selZzimPdCnt')
          .then((res) => {
            if (this.isNotEmpty(res.data.data)) {
              this.zzimPdCnt = res.data.data
            }
          })
      } catch (err) {
        console.log('찜 상품수 조회 error')
        console.log(err)
      }
    },
    selCpnCnt () {
      this.$AxiosBuilder
        .data(this.form)
        .build()
        .post('/ev/evf/selCpnCnt')
        .then((res) => {
          console.log(res)
          if (this.isNotEmpty(res.data.extraData)) {
            this.cpnCn = res.data.extraData.cpnCn // 쿠폰수
          }
        })
        .catch((err) => {
          console.log('쿠폰조회 error')
          console.log(err)
        })
    },

    async selGfCnt () {
      const srchForm = {
        mbMngNo: this.$store.getters['session/getMbMngNo'],
        delYn: 'N',
        sortCd: '01',
        currentPage: 1,
        pageSize: 999
      }
      await this.$AxiosBuilder
        .data(srchForm)
        .build()
        .post('/py/pya/selMbGftList')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            res.data.data.PyaList.forEach((x) => {
              if (x.status === '사용가능') {
                this.blce = Number(this.blce) + x.blce // 상품권잔액 합산
              }
            })
          }
        })
        .catch((err) => {
          console.log('상품권조회 error')
          console.log(err)
        })
    },

    selPsblRevw () {
      try {
        this.$AxiosBuilder
          .data(this.form)
          .build()
          .post('/pd/pdt/myRevw/selPsblRevwCnt')
          .then((res) => {
            if (this.isNotEmpty(res.data.data)) {
              this.revw = res.data.data.psblRevwCnt
            }
          })
      } catch (err) {
        console.log('작성가능한 리뷰 error')
        console.log(err)
      }
    },

    async selRcntPd () { // 최근 본 상품 목록
      const cookiePdNo = await JSON.parse(localStorage.getItem('visitedPdNo'))
      if (cookiePdNo !== undefined && cookiePdNo !== null) {
        this.rcntPd = cookiePdNo.length
      } else {
        this.rcntPd = 0
      }
    },

    async selOftenBuyPdCount () { // 자주 산 상품 건수 조회
      const count = await this.post('/or/orc/selOftenBuyPdCount', { mbMngNo: this.$store.getters['session/getMbMngNo'] }, '자주 산 상품 목록 조회', 'selOftenBuyPdCount')
      if (this.isNotEmpty(count)) {
        this.oftenBuyPdCnt = count
      }
    },
    goSavePrf () {
      this.$router.push({
        name: 'ug-ugp-SCR_UGP_0018',
        params: { returnUrl: window.location.href }
      })
    }
  }
}
